import React from 'react';

interface RangeInputProps {
  label: string;
  minValue: string;
  maxValue: string;
  minOptions: string[];
  maxOptions: string[];
  onMinChange: (value: string) => void;
  onMaxChange: (value: string) => void;
}

export const RangeInput = ({
  label,
  minValue,
  maxValue,
  minOptions,
  maxOptions,
  onMinChange,
  onMaxChange,
}: RangeInputProps) => {
  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">{label}</label>
      <div className="grid grid-cols-[1fr_auto_1fr] items-center gap-2">
        <select
          value={minValue}
          onChange={(e) => onMinChange(e.target.value)}
          className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:border-blue-500"
        >
          {minOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
        <span className="text-gray-500 text-center px-1 whitespace-nowrap">-</span>
        <select
          value={maxValue}
          onChange={(e) => onMaxChange(e.target.value)}
          className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:border-blue-500"
        >
          {maxOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
